<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4"
      y="4"
      width="40"
      height="40"
      rx="20"
      fill="url(#paint0_linear_11963_174)"
    />
    <rect
      x="2"
      y="2"
      width="44"
      height="44"
      rx="22"
      stroke="url(#paint1_linear_11963_174)"
      stroke-opacity="0.33"
      stroke-width="4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.0689 9.40059C26.8449 10.0315 26.971 11.1826 26.3506 11.9717L20.3959 19.5445C19.959 20.1001 19.6259 20.5262 19.3753 20.8672C19.7938 20.8811 20.3291 20.8826 21.0286 20.8826H28.4972C29.5116 20.8824 30.4655 20.8823 31.2042 20.9927C31.9636 21.1063 33.1106 21.421 33.7042 22.6073C34.2979 23.7937 33.8728 24.9217 33.5159 25.6128C33.1688 26.2849 32.6071 27.0688 32.0098 27.9025L24.5993 38.2476C24.0144 39.0642 22.8892 39.244 22.086 38.6492C21.2829 38.0545 21.106 36.9103 21.691 36.0937L29.0288 25.8498C29.4197 25.3041 29.7163 24.8876 29.938 24.5557C29.5437 24.5426 29.038 24.5412 28.374 24.5412H20.9033C19.8341 24.5414 18.8391 24.5415 18.0742 24.428C17.3027 24.3135 16.1051 23.9941 15.5182 22.7528C14.9313 21.5116 15.4337 20.361 15.8276 19.6768C16.2181 18.9985 16.8395 18.2085 17.5074 17.3594L23.5403 9.687C24.1608 8.89793 25.2929 8.7697 26.0689 9.40059ZM18.3655 20.7596C18.3655 20.7596 18.37 20.7609 18.3776 20.764C18.3691 20.7613 18.3655 20.7596 18.3655 20.7596ZM18.8315 21.7239C18.8292 21.732 18.8273 21.7363 18.8273 21.7363C18.8273 21.7363 18.8283 21.7324 18.8315 21.7239Z"
      fill="white"
    />
    <path
      d="M32.2484 11.8365C32.8354 12.3544 32.9193 13.2842 32.436 13.9131L28.9395 18.4625C28.4562 19.0915 27.5885 19.1815 27.0016 18.6635C26.4146 18.1456 26.3307 17.2158 26.814 16.5869L30.3105 12.0375C30.7938 11.4085 31.6615 11.3186 32.2484 11.8365Z"
      fill="white"
    />
    <path
      d="M21.1647 29.9151C21.6925 29.3404 21.5855 28.5018 20.9258 28.0421C20.266 27.5823 19.3033 27.6755 18.7755 28.2502L14.3353 33.0849C13.8075 33.6596 13.9145 34.4982 14.5742 34.9579C15.2339 35.4177 16.1966 35.3245 16.7244 34.7498L21.1647 29.9151Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11963_174"
        x1="4"
        y1="24"
        x2="44"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6172F3" />
        <stop
          offset="1"
          stop-color="#00A89F"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11963_174"
        x1="44"
        y1="24"
        x2="4"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A89F" />
        <stop
          offset="1"
          stop-color="#6172F3"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
